import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
  },
  icon: {
    fontSize: '64px',
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
    fontWeight: 600,
  },
  message: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    maxWidth: '500px',
    marginBottom: theme.spacing(1),
  },
  supportMessage: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: '14px',
    fontStyle: 'italic',
  },
}))
